'use client'

import { useEffect } from 'react'
import { useRoles } from '../../auth/hooks/useRoles'
import {
  DEFAULT_APPS_RULES,
  DEFAULT_ASSOCIATION_RULES
} from '../constants/speculations-rules.constants'
import type {
  IRules,
  SpeculationRule
} from '../../interfaces/src/speculation-rules.interface'

interface GenerateSpeculationRulesParams {
  rules: IRules[]
}

interface SpeculationRules {
  prerender: SpeculationRule[]
}

const IS_LOCAL = process.env.NEXT_PUBLIC_STAGE === 'local'

export const hasSupportSpeculationRules = () => {
  return HTMLScriptElement.supports?.('speculationrules')
}

export const hasSpeculationRulesEnabled = () => {
  return 'speculationRules' in document
}

export const generateSpeculationRules = ({
  rules
}: GenerateSpeculationRulesParams): void => {
  if (!hasSupportSpeculationRules() || IS_LOCAL) {
    return
  }

  const specScript = document.createElement('script')
  specScript.type = 'speculationrules'

  const specRules: SpeculationRules = {
    prerender: rules.map((rule) => ({
      urls: rule.urls,
      eagerness: rule.eagerness || 'moderate'
    }))
  }

  specScript.textContent = JSON.stringify(specRules)
  document.body.append(specScript)
}

export const SpeculationRulesProvider = ({ rules }: { rules?: IRules[] }) => {
  const { isAssociation } = useRoles()

  const getRules = () => {
    if (rules) {
      return rules
    }

    if (isAssociation) {
      return DEFAULT_ASSOCIATION_RULES
    }

    return DEFAULT_APPS_RULES
  }

  useEffect(() => {
    generateSpeculationRules({ rules: getRules() })
  }, [])

  return <></>
}

export default SpeculationRulesProvider
